"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgChartContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
function getLineStyle(lineColor, lineWidth, isTop) {
    if (lineColor === void 0) { lineColor = 'gray'; }
    if (lineWidth === void 0) { lineWidth = 1; }
    if (isTop === void 0) { isTop = false; }
    return "".concat(lineWidth * (isTop ? 2 : 1), "px solid ").concat(lineColor);
}
exports.OrgChartContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  --lineStyle: ", ";\n  --lineTopStyle: ", ";\n  .orgchart {\n    background: none;\n    .node {\n      padding: 0;\n      position: relative;\n      margin: 0 5px;\n    }\n\n    .bottomEdge {\n      bottom: -2px;\n    }\n\n    .lines {\n      & .downLine {\n        background-color: ", ";\n        width: ", ";\n      }\n      & .rightLine {\n        border-right: var(--lineStyle);\n      }\n      & .leftLine {\n        border-left: var(--lineStyle);\n      }\n      & .topLine {\n        border-top: var(--lineTopStyle);\n      }\n    }\n  }\n"], ["\n  --lineStyle: ", ";\n  --lineTopStyle: ", ";\n  .orgchart {\n    background: none;\n    .node {\n      padding: 0;\n      position: relative;\n      margin: 0 5px;\n    }\n\n    .bottomEdge {\n      bottom: -2px;\n    }\n\n    .lines {\n      & .downLine {\n        background-color: ", ";\n        width: ", ";\n      }\n      & .rightLine {\n        border-right: var(--lineStyle);\n      }\n      & .leftLine {\n        border-left: var(--lineStyle);\n      }\n      & .topLine {\n        border-top: var(--lineTopStyle);\n      }\n    }\n  }\n"])), function (_a) {
    var lineColor = _a.lineColor, lineWidth = _a.lineWidth;
    return getLineStyle(lineColor, lineWidth);
}, function (_a) {
    var lineColor = _a.lineColor, lineWidth = _a.lineWidth;
    return getLineStyle(lineColor, lineWidth, true);
}, function (_a) {
    var lineColor = _a.lineColor;
    return lineColor || 'gray';
}, function (_a) {
    var lineWidth = _a.lineWidth;
    return "".concat((lineWidth || 1) * 2, "px");
});
var templateObject_1;
